import Vue from "vue";
import VueRouter from "vue-router";
import index from '@/views/index.vue';
import tabbar1 from '@/views/index/tabbar1.vue';
import tabbar2 from '@/views/index/tabbar2.vue';
import tabbar3 from '@/views/index/tabbar3.vue';
import tabbar4 from '@/views/index/tabbar4.vue';
import tabbar5 from '@/views/index/tabbar5.vue';
// 首页子组件===============================================
import indexs1 from '@/views/indexs/indexs1.vue';
// import indexs2 from '@/views/indexs/indexs2.vue';
// import indexs3 from '@/views/indexs/indexs3.vue';
// import indexs4 from '@/views/indexs/indexs4.vue';
// import indexs5 from '@/views/indexs/indexs5.vue';
// import indexs6 from '@/views/indexs/indexs6.vue';
// import indexs7 from '@/views/indexs/indexs7.vue';
// import indexs8 from '@/views/indexs/indexs8.vue';
// import indexs9 from '@/views/indexs/indexs9.vue';
// import indexs10 from '@/views/indexs/indexs10.vue';
Vue.use(VueRouter);

const router = new VueRouter({
  routes: [{
      path: "",
      redirect: "/index"
    },
    {
      path: "/index",
      component: index,
      children: [{
          path: "",
          redirect: "tabbar1"
        },
        {
          path: "tabbar1",
          component: tabbar1,
        },
        {
          path: "tabbar2",
          component: tabbar2
        },
        {
          path: "tabbar3",
          component: tabbar3
        },
        {
          path: "tabbar4",
          component: tabbar4
        },
        {
          path: "tabbar5",
          component: tabbar5
        },
      ]
    },
    {
      path: "/indexs1",
      component: indexs1
    },
    // {
    //   path: "/indexs2",
    //   component: indexs2
    // },
    // {
    //   path: "/indexs3",
    //   component: indexs3
    // },
    // {
    //   path: "/indexs4",
    //   component: indexs4
    // },
    // {
    //   path: "/indexs5",
    //   component: indexs5
    // },
    // {
    //   path: "/indexs6",
    //   component: indexs6
    // },
    // {
    //   path: "/indexs7",
    //   component: indexs7
    // },
    // {
    //   path: "/indexs8",
    //   component: indexs8
    // },
    // {
    //   path: "/indexs9",
    //   component: indexs9
    // },
    // {
    //   path: "/indexs10",
    //   component: indexs10
    // },
  ],
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
});

export default router;